import { render, staticRenderFns } from "./FormAddItem.vue?vue&type=template&id=ccc099fe&scoped=true"
import script from "./FormAddItem.vue?vue&type=script&lang=js"
export * from "./FormAddItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc099fe",
  null
  
)

export default component.exports